/* eslint-disable import/prefer-default-export */

// Less costly for equality checking
// [] !== [] but EmptyArr === EmptyArr
export const emptyList = [];
export const companyForm = {
  AAFY: 'Virksomhet til ikke-næringsdrivende person',
  ADOS: 'Administrativ enhet - offentlig sektor',
  ANNA: 'Annen juridisk person',
  ANS: 'Ansvarlig selskap med solidarisk ansvar',
  AS: 'Aksjeselskap',
  ASA: 'Allmennaksjeselskap',
  BA: 'Selskap med begrenset ansvar',
  BBL: 'Boligbyggelag',
  BEDR: 'Bedrift',
  BO: 'Andre bo',
  BRL: 'Borettslag',
  DA: 'Ansvarlig selskap med delt ansvar',
  ENK: 'Enkeltpersonforetak',
  EOFG: 'Europeisk økonomisk foretaksgruppe',
  ESEK: 'Eierseksjonssameie',
  FKF: 'Fylkeskommunalt foretak',
  FLI: 'Forening/lag/innretning',
  FYLK: 'Fylkeskommune',
  GFS: 'Gjensidig forsikringsselskap',
  IKJP: 'Andre ikke-juridiske personer',
  IKS: 'Interkommunalt selskap',
  KBO: 'Konkursbo',
  KF: 'Kommunalt foretak',
  KIRK: 'Den norske kirke',
  KOMM: 'Kommune',
  KS: 'Kommandittselskap',
  KTRF: 'Kontorfellesskap',
  NUF: 'Norskregistrert utenlandsk foretak',
  OPMV: 'Særskilt oppdelt enhet, jf. mval. § 2-2',
  ORGL: 'Organisasjonsledd',
  PERS: 'Andre enkeltpersoner som registreres i tilknyttet register',
  PK: 'Pensjonskasse',
  PRE: 'Partrederi',
  SA: 'Samvirkeforetak',
  SAM: 'Tingsrettslig sameie',
  SE: 'Europeisk selskap',
  SF: 'Statsforetak',
  SPA: 'Sparebank',
  STAT: 'Staten',
  STI: 'Stiftelse',
  SÆR: 'Annet foretak iflg. særskilt lov',
  TVAM: 'Tvangsregistrert for MVA',
  UTLA: 'Utenlandsk enhet',
  VPFO: 'Verdipapirfond',
  UKJENT: 'ukjent',
  UDEF: 'ukjent',
  ANNET: 'Annet'
};